$(document).on("click", "#AddToCartFirst", function(){
  $(".productContentInner").find(".sizeMessage").children(".alertmsg").remove();
  var msg = '<span class="alertmsg" style="color:red;"> Please select a size</span>';
  $(".productContentInner").find(".sizeMessage").append(msg);
});


/*  var mainObj = [];
$("#ProductSelect").children("option").each(function(){
  var getInv = $(this).attr("inventory");
  var color = $(this).attr("colval");
  var size = $(this).attr("sizeval");
  var fit = $(this).attr("fitval");
  var varId = $(this).val();
  if(getInv <= 0){
     mainObj.push({varId: varId, size: size, fit: fit, color: color });
  }
});
$(document).ready(function(){
  setTimeout(function(){
    $("#klaviyo-bis-iframe").addClass("potato");
    $("#klaviyo-bis-iframe").contents().find("#variants").html("");
    var createOption = "";
        $(mainObj).each(function (i, value) {
         createOption = '<option value="'+value.varId+'">'+value.size+" / "+value.color+" / "+value.fit+'</option>';
          $("#klaviyo-bis-iframe").contents().find("#variants").append(createOption);
        });
    
  },2000);

 $("#klaviyo-bis-iframe").contents().show(function(){
    debugger
        $(this).contents().contents().find("#variants").html("");
            var createOption = "";
        $(mainObj).each(function (i, value) {
         createOption = '<option value="'+value.varId+'">'+value.size+" / "+value.color+" / "+value.fit+'</option>';
          $(this).contents().find("#variants").append(createOption);
        });
        });
 
   // });
});*/

$(document).on("click", "#AddToCartNew", function (event) {
      var color = $("#coreColorBlock").children("li.active").children("span").attr("value");
   var test = $("#fitBlocks").html().trim();
   if(test == ""){
     var fit = "unavail";
   }
   else{
     var fit = $("#fitBlocks").find(".fitBoxNew.focus").attr("value");
   }
      var size =  $("#sizeBlocks").find(".sizeBoxNew.focus").attr("value");
   
     
   if(fit == "unavail"){
     var combinedVal = size +" / "+ color;
   }
   else{
     var combinedVal = size +" / "+ color + " / "+ fit;
   }
      
      var valueSelected = "";
      $("#ProductSelect").children("option").each(function(){
        var el = $(this);
        var selectVal = $(this).html();
        if(combinedVal == selectVal){
           valueSelected = $(el).val();
        }
      });
 
            //window.history.pushState({ path: getUrl }, '', getUrl);
            var element = $(this);
          //  $(element).prop('disabled', true);
             event.preventDefault();
           // var qty = $('.qv-quantity').val();
           // var var_id = $("#ProductSelect").val();
              var formOBJ = {
                id: valueSelected
              };
              $.ajax({
      		type: "POST",
      		url: "/cart/add.js",
      		cache:false,
      		data:formOBJ,
      		dataType: "json",
      		success: function (data) {
                  // $(".fancybox-close").trigger("click");
                  if ("redirect" == theme.settings.afterAddition) return (window.location = "/cart"), !1;
                  theme.MiniCart.update()
                      .promise()
                      .done(function () {
                  });
              },
              error: function (xhr, ajaxOptions, thrownError) {
                  console.log("error");
                  console.log(xhr.status);
                  console.log(thrownError);
              }
            });
          });



/*const observerConfig = {
  attributes: true,
  childList: true,
  characterData: true
};
const observer = new MutationObserver((mutations) => {
  mutations.forEach((mutation) => {
      if(mutation.type == "childList"){
        $(".restock-alerts-modal-wrapper").find(".restock-alerts-variant-select").html("");
        $(mainObj).each(function (i, value) {
        var createOption = '<option value="'+value.varId+'">'+value.size+" / "+value.color+" / "+value.fit+'</option>';
          
      $(".restock-alerts-modal-wrapper").find(".restock-alerts-variant-select").append(createOption);
    });
      }
  });
});
observer.observe(document.body, observerConfig);*/


function setSliderImages(clr){
  var color = clr;
  var clrImg = $(color).children("span").attr("data-img");
   clrImg  = clrImg.split('?')[0];
  $(".product-single__thumbnails-item").each(function(){
    var elem = $(this);
    var sliderImg = $(this).find(".product-single__thumbnail").attr("imagesrc");
    if(sliderImg != undefined){
    sliderImg  = sliderImg.split('?')[0];
    }
    if(clrImg == sliderImg){
      $(elem).trigger("click");
    } 
  });
}
var colorImages = [];
  $(document).on("click", ".optionColor", function (){
    $("#productImages").children(".ImagesColorVariants").html("");
    var elem = $(this);    
    $("#productImages").find(".ImagesColorVariants").remove();
    $(".sizeBlocksMobile").children(".sizeBoxNew").removeClass("not_avail");
    $(".sizeBlocksMobile").children(".sizeBoxNew").removeClass("available");
    $(".FitBlocksMobile").children(".fitBoxNew").removeClass("not_avail");
    $(".FitBlocksMobile").children(".fitBoxNew").removeClass("available");
     $(".coreColorGroup li").removeClass("available").removeClass("not_avail");
    $(elem).parents(".colorWrapper").siblings(".colorWrapper").find(".coreColorGroup").children("li").removeClass("active");
    $(elem).siblings("li").removeClass("active");
    $(elem).addClass("active");
    var sizeObject = [];
    var fitObject = [];
    var newImages = [];
    var colValue = $(elem).children("span").attr("value");
    var fitValue = $("#fitBlocks").find(".focus").attr("value");
    var sizeValue = $("#sizeBlocks").find(".focus").attr("value");
    
    $(elem).parents(".colorWrapper").siblings(".colorWrapper").find(".colorDisplay").text("");
    $(elem).parents(".colorWrapper").find(".colorDisplay").html(colValue);
     var testCol = colValue.toLowerCase();
         testCol = testCol.replace(" ","-");
    var OOS = [];

      $("#ProductSelect").children("option").each(function(){
      var color = $(this).attr("colval");
      var size = $(this).attr("sizeval");
      var fit = $(this).attr("fitval");
        var varId = $(this).val();
        var price = $(this).attr("price");
        var Comprice = $(this).attr("compar");
        var img1 = $(this).attr("colorimagessrc1");
        var inventoryChk = $(this).attr("inventory");
      var variantImages = $(this).attr("imagesrc");
       var getImages =  $(this).attr("colorImagesSrc");
      if(colValue == color){
        if(inventoryChk > "0"){
          if(fitValue == fit){
          sizeObject.push(size);
            if(sizeValue == size){
              $("#moneySpan").html(price);
              $("#moneyCom").html(Comprice);
            }
            
          }
        fitObject.push(fit);
        newImages.push(getImages);
          
        }
        else{
          if(fitValue == fit){
          OOS.push(size);
          }
           
        }
      }

        if(colValue == color){
          if(img1 != ""){
          var varImg1 = $(this).attr("colorimagessrc1");
          var varImg2 = $(this).attr("colorimagessrc2");
          var varImg3 = $(this).attr("colorimagessrc3");
          var varImg4 = $(this).attr("colorimagessrc4");
          var varImg5 = $(this).attr("colorimagessrc5");
          var varImg6 = $(this).attr("colorimagessrc6");
          colorImages.push(varImg1, varImg2, varImg3, varImg4, varImg5, varImg6);
          }
        }
        
    });
    var loadImagesColor = newImages.filter(function (el) {
      return el != null && el != "";
    });
    sizeObject = sizeObject.filter(function(itm, i, sizeObject) {
      return i == sizeObject.indexOf(itm);
    });
    fitObject = fitObject.filter(function(itm, i, fitObject) {
      return i == fitObject.indexOf(itm);
    });
    
    $(".sizeBoxNew").each(function(){
      var elem = $(this);
      var elVal = $(this).attr("value");
       if(sizeObject.length == 0){
        $(elem).addClass("not_avail");
      }
      else{
      for(var demo =0;demo<sizeObject.length;demo++){
      if(sizeObject[demo] == elVal){
        $(elem).addClass("available");
      }
        else{
          $(elem).addClass("oops");
        }
      }
        for(var demo =0;demo<OOS.length;demo++){
      if(OOS[demo] == elVal){
        $(elem).addClass("not_avail");
      }
           else{
          $(elem).addClass("oops");
        }
      }
      }
    });
     $(".FitBlocksMobile .fitBoxNew").each(function(){
      var element = $(this);
      var elemVal = $(this).attr("value");
      for(var demo =0;demo<fitObject.length;demo++){
      if(fitObject[demo] == elemVal){
        $(element).addClass("available");
      }
        else{
          $(element).addClass("not_avail");
        }
      }
    });
    $(".sizeBlocksMobile").children(".sizeBoxNew.available").removeClass("oops");
     $(".sizeBlocksMobile").children(".sizeBoxNew.not_avail").removeClass("oops");
     $(".FitBlocksMobile").children(".fitBoxNew.available").removeClass("not_avail");
   
    if($(".fitBoxNew.not_avail").hasClass("focus")){
        $(".fitBoxNew.not_avail").removeClass("focus");
        $(".fitBoxNew.available").first().addClass("focus");
      }
   $(".sizeBoxNew.focus").trigger("click");
setSliderImages(elem);
$("#productImages").append("<div class='ImagesColorVariants'></div>");
    var getProdName = $(".product-single__title").text();
    var getVendorName = $(".product_vendor_name").html();
   getProdName = getProdName.trim();
   
     var myArrayNew = colorImages.filter(function (el) {

    return el != null && el != "";

  });
    var lastLoop = myArrayNew.length;
      for(var demo = 0;demo<colorImages.length;demo++){
        var createAlt = getProdName+' - '+colValue+' - '+getVendorName+' - '+parseInt(demo+1);
        
        if(colorImages[demo]){
        if(demo == lastLoop-1){
          if($("#videoGroup").html().trim() != ""){
            var videoClone = $("#videoGroup").find("source").attr("src");
            var variantImg = '<div class="imagesLoop"><img src="'+colorImages[demo]+'" alt="'+createAlt+'" width="400" height="600"></div>'+
              '<div class="imagesLoop"><video width="320" height="240"  controlsList="nofullscreen" playsinline="playsinline" autoplay loop ><source src="'+videoClone+'" type="video/mp4"></video></div>';
                      $("#productImages").children(".ImagesColorVariants").append(variantImg);
          }
          else{
            var variantImg = '<div class="imagesLoop"><img src="'+colorImages[demo]+'" alt="'+createAlt+'" width="400" height="600" ></div>';
            $("#productImages").children(".ImagesColorVariants").append(variantImg);
          }
        }
           else {
           var variantImg = '<div class="imagesLoop"><img src="'+colorImages[demo]+'" alt="'+createAlt+'" width="400" height="600" ></div>';
            $("#productImages").children(".ImagesColorVariants").append(variantImg);
          }
        }
       
        
          createAlt = "";
        if($(window).width() < 700){
         // setTimeout(function(){
          createSlick();
         // },50);
        }
        
      }
   

  colorImages = [];
   /* var valueSelectedNew = "";
    if(sizeValue != undefined){
    var combinedVal = sizeValue +" / "+ colValue + " / "+ fitValue;
     $("#ProductSelect").children("option").each(function(){
        var el = $(this);
        var selectVal = $(this).html();
        if(combinedVal == selectVal){
           valueSelectedNew = $(el).val();
        }
      });
 var refresh = window.location.protocol + "//" + window.location.host + window.location.pathname + '?variant=' + valueSelectedNew;    
window.history.pushState({ path: refresh }, '', refresh);
     // window.top.location = window.top.location;
    }*/
  });


  $(document).on("click", ".optionSize", function (){
    $("#AddToCartFirst").addClass("hide");
    $("#AddToCartNew").removeClass("hide");
      $(".productContentInner").find(".sizeMessage").children(".alertmsg").remove();
    var elem = $(this);
    $(elem).siblings(".sizeBoxNew").removeClass("focus");
    $(elem).addClass("focus");
    if($(elem).hasClass("not_avail")){
      $("#AddToCartNew").addClass("unavail");
      $("#AddToCartNew").html("Currently Unavailable");
      $("#klaviyoBtn .btn").removeClass("disabled");
    }
    else{
      $("#AddToCartNew").removeClass("unavail");
      $("#AddToCartNew").html("Add To Cart");
      $("#klaviyoBtn .btn").addClass("disabled");
    }
     var sizeVal = $(elem).attr("value");
     var fitVal = $("#fitBlocks").children(".focus").attr("value");
    var colorValCore = $("#coreColorBlock").find(".active").children("span").attr("value");
     $("#ProductSelect").children("option").each(function(){
      var inventoryChk = $(this).attr("inventory");
      var color = $(this).attr("colval");
      var size = $(this).attr("sizeval");
      var fit = $(this).attr("fitval");
      var price = $(this).attr("price");
       var Comprice = $(this).attr("compar");
      if(inventoryChk > "0"){
      if(sizeVal == size){
        if(fitVal == fit){
        if(colorValCore == color){
        $("#moneySpan").html(price);
           $("#moneyCom").html(Comprice);
        }
        }
      }
      }
    });
   
  });

  $(document).on("click", ".optionFit", function (){
    var elem = $(this);
    $(elem).addClass("focus");
    $(elem).siblings(".fitBoxNew").removeClass("focus");
     $(".sizeBlocksMobile").children(".sizeBoxNew").removeClass("not_avail");
    $(".sizeBlocksMobile").children(".sizeBoxNew").removeClass("available");
    $(".coreColorGroup li").removeClass("available").removeClass("not_avail");
     var sizeObject = [];
    var colorObject = [];
    var fitVal = $(elem).attr("value");
    var colorValCore = $("#coreColorBlock").find(".active").children("span").attr("value");
    var OOS = [];
    $("#ProductSelect").children("option").each(function(){
      var inventoryChk = $(this).attr("inventory");
      var color = $(this).attr("colval");
      var size = $(this).attr("sizeval");
      var fit = $(this).attr("fitval");
      var price = $(this).attr("price");
      var Comprice = $(this).attr("compar");
      
      if(fitVal == fit){
        if(inventoryChk > "0"){
        if(colorValCore == color){
          sizeObject.push(size);
          $("#moneySpan").html(price);
           $("#moneyCom").html(Comprice);
        }
        colorObject.push(color);
        
      }
        else{
        if(colorValCore == color){
        OOS.push(size);
        }
      }
      }
      
    });
    sizeObject = sizeObject.filter(function(itm, i, sizeObject) {
      return i == sizeObject.indexOf(itm);
    });
    colorObject = colorObject.filter(function(itm, i, colorObject) {
      return i == colorObject.indexOf(itm);
    });
    $(".sizeBoxNew").each(function(){
      var elem = $(this);
      var elVal = $(this).attr("value");
       if(sizeObject.length == 0){
        $(elem).addClass("not_avail");
      }
      else{
      for(var demo =0;demo<sizeObject.length;demo++){
      if(sizeObject[demo] == elVal){
        $(elem).addClass("available");
      }
      else{
          $(elem).addClass("oops");
        }
      }
        for(var demo =0;demo<OOS.length;demo++){
      if(OOS[demo] == elVal){
        $(elem).addClass("not_avail");
      }
           else{
          $(elem).addClass("oops");
        }
        }
      }
    });
     $(".coreColorGroup li").each(function(){
      var element = $(this);
      var elemVal = $(this).children("span").attr("value");
      for(var demo =0;demo<colorObject.length;demo++){
      if(colorObject[demo] == elemVal){
        $(element).addClass("available");
      }
        else{
          $(element).addClass("not_avail");
        }
      }
    });
    
   $(".sizeBlocksMobile").children(".sizeBoxNew.available").removeClass("oops");
     $(".sizeBlocksMobile").children(".sizeBoxNew.not_avail").removeClass("oops");
     $(".coreColorGroup").children("li.available").removeClass("not_avail");

    //$(".sizeBoxNew.focus").trigger("click");
  });

  $(document).ready(function(){
    setTimeout(function(){
      $(".coreColorGroup").children("li").first().trigger("click");
    },1000);
  });

$(document).on("click", ".accordion_icon .plus", function(){
  $(this).parents("#testAcc").find(".custom-color-swatch.curSwatch").trigger("click");
});
    /*var elem = $(this).parents(".accon").children(".panel");
  var get_productHandle = $(this).parents(".accordion").attr("prodTitle");
  $(elem).find("#RPcontainer_"+get_productHandle).find(".RPcolor").empty();
  $(elem).find("#RPcontainer_"+get_productHandle).find(".RPsize").empty();
  $(elem).find("#RPcontainer_"+get_productHandle).find(".RPfit").empty();
  var get_productHandle = $(this).parents(".accordion").attr("prodTitle");
     jQuery.getJSON('/products/' + get_productHandle + '.js', function (product) {
        var title = product.title;
      var type = product.type;
      var vendor = product.vendor;
      var desc = product.description;
      var images = product.images;
      var variants = product.variants;
      var options = product.options;
       
        $(options).each(function (i, option) {
        var opt = option.name;
         $(option.values).each(function (i, value) {
           var dataColorname = value.toLowerCase();
            dataColorname = dataColorname.replace(/ /g, "-");
          if(opt == "Color"){
            var createColor = '<label data-colorname="'+dataColorname+'" title="'+value+'" data-name="'+dataColorname+'" class="custom-color-swatch" onclick="RPcolorFilter(this)">'+
                              '<input type="radio" value="'+value+'" data-color-name="'+value+'" style="display:none" tabindex="0"></label>'
            $(elem).find("#RPcontainer_"+get_productHandle).find('.RPcolor').append(createColor);
          }
            else if(opt == "Size"){
              var createSize = '<div class="cmpsetsizeBoxNew  availablesetSize" attrnew="" name="set-Size" value="'+value+'" onclick="RPchangeSizes(this)">'+value+'</div>';
                $(elem).find("#RPcontainer_"+get_productHandle).find('.RPsize').append(createSize);
            }
          else{
            var createFit = '<div class="cmpsetfitBoxNew availablesetFit" attrnew="" name="set-Fit" value="'+value+'" onclick="RPglobalElemClick(this)">'+value+'</div>';
           $(elem).find("#RPcontainer_"+get_productHandle).find('.RPfit').append(createFit);
          }
        });
      });
     });
  setTimeout(function(){
     $(elem).find(".custom-color-swatch").first().trigger("click");
  },1500);
  
});*/



function RPcolorFilter(elem){
   var featuredImage = "";
  var IMageRep = $(elem).attr("data-img");
  $(elem).parents(".colorContent").siblings(".colorContent").find(".custom-color-swatch.curSwatch").removeClass("curSwatch");
  $(elem).parents("#testAcc").find(".completeTheSetProd").children("img").attr("srcset", IMageRep);
  $(elem).siblings("label").removeClass("curSwatch");
  $(elem).addClass("curSwatch");
    $(elem).parents(".RPcontent").find(".cmpsetsizeBoxNew").removeClass("available");
   $(elem).parents(".RPcontent").find(".cmpsetfitBoxNew").removeClass("available");
   
    // $(".custom-color-swatch").removeClass("available").removeClass("not_avail");
    filteredSizes = [];
  filteredFits = [];
  var colSelectedVal = $(elem).attr("title");
  $(elem).parents(".colorContent").siblings(".colorContent").find(".selectedColorDisplay").text("");
  $(elem).parents(".colorContent").find(".selectedColorDisplay").text(colSelectedVal);
var selectedFit = $(elem).parents(".RPcontent").find(".RPfitBoxes").children(".focus").attr("value");
  var selectedSize = $(elem).parents(".RPcontent").find(".RPsizeBoxes").children(".focus").attr("value");
  $(elem).parents(".RPcontent").find("#ProductSelectPro").children("option").each(function(){
    var element  = $(this);
    var color = $(this).attr("colval");
    var size = $(this).attr("sizeval");
    var fit = $(this).attr("fitval");
    var inventory = $(this).attr("inventory");
    var price = $(this).attr("price");
      var Comprice = $(this).attr("compare");
    if(colSelectedVal == color){
       if(inventory > 0){
        if(selectedFit == fit){
        filteredSizes.push(size);
          if (selectedSize == size) {
            $(elem).parents("#testAcc").find(".CTS_price").html(price);
          $(elem).parents("#testAcc").find(".CTS_priceCom").html(Comprice);
          }
        }
        filteredFits.push(fit);
      }
    }
  });

    var uniqueSize = filteredSizes.filter(function(itm, i, filteredSizes) {
      return i == filteredSizes.indexOf(itm);
    });

    var uniqueFit = filteredFits.filter(function(itm, i, filteredFits) {
        return i == filteredFits.indexOf(itm);
    });  

  $(elem).parents(".RPcontent").find(".cmpsetsizeBoxNew").each(function(){
    var element = $(this);
    var elemVal = $(this).attr("value");
     if(uniqueSize.length == 0){
        $(element).addClass("not_avail");
      }
    else{
    for(var demo =0;demo<uniqueSize.length;demo++){
    if(uniqueSize[demo] == elemVal){
      $(element).addClass("available");
    }
      else{
        $(element).addClass("not_avail");
      }
    }
    }
  });

 $(elem).parents(".RPcontent").find(".cmpsetfitBoxNew").each(function(){
    var element = $(this);
    var elemVal = $(this).attr("value");
    for(var demo =0;demo<uniqueFit.length;demo++){
    if(uniqueFit[demo] == elemVal){
      $(element).addClass("available");
    }
      else{
        $(element).addClass("d-none");
      }
    }
  });
       $(elem).parents(".RPcontent").find(".cmpsetsizeBoxNew.available").removeClass("not_avail");
     $(elem).parents(".RPcontent").find(".cmpsetfitBoxNew.available").removeClass("d-none");
  
  var color = $(elem).parents(".RPcontent").find(".custom-color-swatch.curSwatch").attr("title");
   var size = $(elem).parents(".RPcontent").find(".cmpsetsizeBoxNew.focus");
    // getsetvaraintSelectedval(color, size, fit, seaColor, elem);
  RPchangeSizes(size);
  $(elem).find(".selectedColorDisplay").text(color);
 
}

function RPchangeSizes(elem){
  var elSize = $(elem).attr("value");
    $(elem).siblings("div").removeClass("focus");
    $(elem).addClass("focus");
    if($(elem).hasClass("not_avail")){
        $(elem).parents(".RPcontent").find(".RPAddToCart").html("Currently Unavailable");
         $(elem).parents(".RPcontent").find(".RPAddToCart").addClass("unav");
    }
  else{
     $(elem).parents(".RPcontent").find(".RPAddToCart").html("Add To Cart");
             $(elem).parents(".RPcontent").find(".RPAddToCart").removeClass("unav");
  }
   var color = $(elem).parents(".RPcontent").find(".custom-color-swatch.curSwatch").attr("title");
  var seaColor = $(elem).parents(".RPcontent").find(".RPseasonalColor").children(".custom-color-swatch.curSwatch").attr("title");
   var size = $(elem).parents(".RPcontent").find(".cmpsetsizeBoxNew.focus").attr("value");
     var fit = $(elem).parents(".RPcontent").find(".cmpsetfitBoxNew.focus").attr("value");
     getsetvaraintSelectedval(color, size, fit, seaColor, elem);
  $(elem).siblings("div").removeClass("focus");
  $(elem).addClass("focus");
 
  $(elem).parents(".RPcontent").find("#ProductSelectPro").children("option").each(function(){
    var element  = $(this);
    var clr = $(this).attr("colval");
    var sizes = $(this).attr("sizeval");
    var fits = $(this).attr("fitval");
    var inventory = $(this).attr("inventory");
     var price = $(this).attr("price");
      var Comprice = $(this).attr("compare");
      if(inventory > 0){
        if(size == sizes){
          if(color == clr){
             $(elem).parents("#testAcc").find(".CTS_price").html(price);
          $(elem).parents("#testAcc").find(".CTS_priceCom").html(Comprice);
          }
        }
      }
  
  });
}
  
function RPglobalElemClick(elem){
  var filteredColor = [];
  var filteredSizes = [];
  var filteredFits = [];
  $(elem).parents(".RPcontent").find(".cmpsetsizeBoxNew").removeClass("available");
  $(elem).parents(".RPcontent").find(".custom-color-swatch").removeClass("available");
     $(elem).parents(".RPcontent").find(".custom-color-swatch").removeClass("not_avail");
  var selectedColor = $(elem).parents(".RPcontent").find(".curSwatch").attr("title");
  var elFit = $(elem).attr("value");
  $(elem).siblings("div").removeClass("focus");
  $(elem).addClass("focus");
 
  $(elem).parents(".RPcontent").find("#ProductSelectPro").children("option").each(function(){
    var element  = $(this);
    var color = $(this).attr("colval");
    var size = $(this).attr("sizeval");
    var fit = $(this).attr("fitval");
    var inventory = $(this).attr("inventory");
     var price = $(this).attr("price");
      var Comprice = $(this).attr("compare");
      if(inventory > 0){
        if(elFit == fit){
          if(selectedColor == color){
             $(elem).parents("#testAcc").find(".CTS_price").html(price);
          $(elem).parents("#testAcc").find(".CTS_priceCom").html(Comprice);
            filteredSizes.push(size);
          }
          filteredColor.push(color);
        }
      }
  
  });
 
  var uniqueSize = filteredSizes.filter(function(itm, i, filteredSizes) {
    return i == filteredSizes.indexOf(itm);
});

var uniqueColor = filteredColor.filter(function(itm, i, filteredColor) {
    return i == filteredColor.indexOf(itm);
});

  $(elem).parents(".RPcontent").find(".cmpsetsizeBoxNew").each(function(){
    var element = $(this);
    var elemVal = $(this).attr("value");
    for(var demo =0;demo<uniqueSize.length;demo++){
    if(uniqueSize[demo] == elemVal){
      $(element).addClass("available");
    }
      else{
        $(element).addClass("not_avail");
      }
    }
  });

     $(elem).parents(".RPcontent").find(".RPseasonalColor .custom-color-swatch").each(function(){
    var element = $(this);
    var elemVal = $(this).attr("title");
    for(var demo =0;demo<uniqueColor.length;demo++){
    if(uniqueColor[demo] == elemVal){
      $(element).addClass("available");
    }
      else{
        $(element).addClass("not_avail");
      }
    }
  });
   $(elem).parents(".RPcontent").find(".RPcoreColor .custom-color-swatch").each(function(){
    var element = $(this);
    var elemVal = $(this).attr("title");
    for(var demo =0;demo<uniqueColor.length;demo++){
    if(uniqueColor[demo] == elemVal){
      $(element).addClass("available");
    }
      else{
        $(element).addClass("not_avail");
      }
    }
  });
    
    $(elem).parents(".RPcontent").find(".cmpsetsizeBoxNew.available").removeClass("not_avail");
   //  $(".FitBlocksMobile").children(".fitBoxNew.available").removeClass("d-none");
     $(elem).parents(".RPcontent").find(".custom-color-swatch.available").removeClass("not_avail");
    
   var size = $(elem).parents(".RPcontent").find(".cmpsetsizeBoxNew.focus");
  RPchangeSizes(size);
    // getsetvaraintSelectedval(color, size, fit, seaColor, elem);
}

$(document).on("click", ".RPAddToCart", function () {
  let cur = this;
  let el = $(this).parents(".contentRP");
  let arritems = [];

	let selecVaraint = $(el).find(".sel_variant_id").val(); 
    let newobj = {id:selecVaraint,quantity:1};
    if(arritems.includes(newobj,0)){
       arritems.map(obj => arritems.find(o => o.selecVaraint === obj.selecVaraint) || newobj);
      
    }else{
       arritems.push(newobj);
    }
  
  fetch('/cart/add.js', {
    method: "post",
    headers: { 'content-type': 'application/json' },
    body: JSON.stringify({items:arritems})
  }) 
  .then(response => {
 
    //$(".minicart").addClass("opened"); 
   console.log(response.json());
       theme.MiniCart.update();
})
.catch((error) => {
  console.error('Error:', error);
});
  
});
		

  function getsetvaraintSelectedval(color, size, fit, seaColor, elem){
   let comel =  $(elem).parents(".contentRP");
 if(color != ""){
   var combtext  = (fit) ?  size + " / " + color + " / " + fit :size + " / " + color ;
 }else{
      var combtext  = (fit) ?  size + " / " + seaColor + " / " + fit :size + " / " + seaColor ;
    }
    
  
    $(comel).find("#ProductSelectPro option").each(function(){
      let title = $(this).attr("new");
      if(title == combtext){ 
        let value = $(this).attr("value");
        let img_src = $(this).attr("data-variant-src");
        let cmp = $(this).attr("compareprice");
        let price = $(this).attr("price");
       
        $(comel).find(".sel_variant_id").val(value);
        
        //return false;
      }
    
    });
  }

$(document).ready(function(){
  const searchParams = new URLSearchParams(window.location.search);
var test = searchParams.get('variant');
  if(test){
   // $(".colorWrapper .colorLabel").hide();
  
  var hideColor = "";
  var selectSize = "";
    var selectFit = "";
 $("#ProductSelect").children("option").each(function(){
   var getValue = $(this).val();
   var clr = $(this).attr("colval");
   clr = clr.replace(" ", "-");
   clr = clr.toLowerCase();
   var size = $(this).attr("sizeval");
   var fit = $(this).attr("fitval");
   if(test == getValue){
     hideColor = clr;
     selectSize = size;
     selectFit = fit;
     return false;
   }
 });
    setTimeout(function(){
  $("#coreColorBlock").find("span[data-colorname="+hideColor+"]").parent("li").trigger("click");
      $("#seasonalColorBlocks").find("span[data-colorname="+hideColor+"]").parent("li").trigger("click");
  $("#sizeBlocks").children("div[value="+selectSize+"]").trigger("click");
      $("#fitBlocks").children("div[value="+selectFit+"]").trigger("click");
       },1000);
    }


 setTimeout(function(){
      $(".optionColor.active").trigger("click");
    },3500);
  
});
